module.exports = {"530403001":"大街街道","530403101":"江城镇","530403102":"前卫镇","530403103":"九溪镇","530403104":"路居镇","530403201":"安化彝族乡","530403202":"雄关乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530403.json
// module id = 2375
// module chunks = 0